import { ICard } from "../models/card/ICard";
import { sounds } from "../sounds/sound";
import { SoundsCardMap } from "../sounds/SoundsCardMap";
import { SoundsMiddlewareMap } from "../sounds/SoundsMiddlewareMap";
import { store } from "../store";


export const SoundsService = {


    playSound: function(sound: { play: () => void; }){
        sound.play();
    },
    playMiddlewareAbility: function(cardId: number){

        let cardSound = sounds.battle_play_spell();

        if(SoundsMiddlewareMap.hasOwnProperty(cardId)){
            cardSound = SoundsMiddlewareMap[cardId]();
        }

        if(cardSound !== null) {
            cardSound.play();
        }
    },

    playCard: function(card: ICard | null, handKey: any = null){

    if(card === null){

        const state = store.getState();
        let playerHand = state.game.playerHand;

        if(handKey !== null && playerHand[handKey] !== null){
            card = playerHand[handKey];
        }else{
           return;
        }
    }
    if(card === null){
        return;
    }

    let cardId:any = card.id;
    if(card?.ability?.tae && card?.ability?.type_effect === 'sacrifice'){
        // @ts-ignore
        cardId = card.id + '-' + card?.ability.tae.animation;
    }

    let cardSound = SoundsService.getSoundByCardId(cardId);

    if(cardSound !== null){
        cardSound.play();
        return;
    }
  
     if(card.type_card === 'spell'){
        sounds.battle_play_spell().play();
     }

     if(card.type_card === 'unit'){
        sounds.battle_play_unit().play();
     }

    },

    getSoundByCardId: function(cardId: any){
        if(SoundsCardMap.hasOwnProperty(cardId)){
            return SoundsCardMap[cardId]();
        }
      return null;
    }

}